<template>
  <main class="no-english flex-all-center">
    <p class="note">English page is not available.</p>
  </main>
</template>

<script>
export default {
  name: "NotEnglish",
};
</script>

<style scoped>
.no-english {
  margin: 40px;
  .note {
    line-height: 1.5;
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/NotEnglish.vue